/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/*
Author: Granite Bagas
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { View, StyleSheet, Dimensions } from 'react-native';
import moment from 'moment-timezone';
import SociollaText from '@components/sociolla/SociollaText';
import ItemDetail from '@components/global/ItemDetail';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import * as Layout from '@components/screen/Layout';
import { isWeb } from '@global/screens';
import { hasNoAccess, parseDate } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import StatusBadge from '@components/global/StatusBadge';
import Image from '@components/global/Image';
import { setTempData, showAlert } from '@/store/global';
import { showPopup } from '@/store/modal';
import Toast from 'react-native-toast-message';
import ProductItem from '@components/global/ProductItem';
import MoreButton from '@components/navbar/MoreButton';
import ScrollContainer from '@components/global/ScrollContainer';

const { height: windowHeight } = Dimensions.get('window');

const trash = {
  width: 12,
  height: 16,
};

const InventoryDetailScreen = (props) => {
  const dispatch = useDispatch();

  const [detailData, setDetailData] = useState({});
  const [products, setProducts] = useState([]);
  useState(false);

  const getInventoryDetail = useApi(MsOrder.getInventoryDetail);
  const img = require('@/assets/img/default/image-default.png');

  const showEditButton = !hasNoAccess([
    'superadmin',
    'salesman',
    'branch_head',
    'sales_admin',
    'spv_logistic',
    'general',
  ]);

  const getDetail = async (id) => {
    const response = await getInventoryDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;
      dispatch(setTempData(result.status));
      setDetailData(result);
      await getProducts(result);
    }
  };

  const getProducts = async (detail) => {
    const response = await MsOrder.calculateInventoryStock({
      warehouse_id: detail.warehouse.pacman_warehouse_id,
      inventory_type: detail.inventory_type,
      salesman_id: detail.user.id,
      products: detail.products,
    });
    const stockAvailable = response?.data?.data;
    setProducts(stockAvailable);
  };

  const goBack = () => {
    props.navigation.replace('InventoryDetailScreen', {});
    props.navigation.navigate('InventoryScreen');
  };

  const goToEdit = () => {
    props.navigation.replace('InventoryFormScreen', {
      id: detailData._id,
      name: detailData.user.name ? detailData.user.name : '-',
      titleScreen: detailData.user.name ? detailData.user.name : '-',
    });
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      dispatch(setTempData(null));
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    if (!isWeb && detailData.status == 'draft' && showEditButton) {
      const menus = [
        {
          type: 'function',
          name: 'Edit',
          callback: goToEdit,
        },
        { type: 'function', name: 'Delete', callback: handleDelete },
      ];

      if (isAvailableSubmit()) {
        menus.push({
          type: 'function',
          name: 'Submit',
          callback: handleSubmit,
        });
      }

      props.navigation.setOptions({
        headerRight: () => <MoreButton menu={menus} {...props} />,
      });
    } else {
      props.navigation.setOptions({
        headerRight: () => false,
      });
    }
  }, [detailData, props, products]);

  const isAvailableSubmit = () => {
    const requiredFields = Boolean(
      detailData.inventory_type &&
        detailData?.sales_team?.id &&
        detailData?.user?.id &&
        detailData?.warehouse?.id &&
        products?.length > 0 &&
        detailData?.esign_requestor?.name &&
        detailData?.esign_requestor?.image &&
        detailData?.esign_approver?.name &&
        detailData?.esign_approver?.image,
    );
    return requiredFields;
  };

  const parseInventoryType = (inventoryType) => {
    if (inventoryType === 'add') {
      return 'Add Inventory';
    }
    return 'Return Inventory';
  };
  const handleSubmit = async () => {
    if (!isAvailableSubmit()) {
      Toast.show({ text1: 'Please complete all data', type: 'error' });
      return;
    }

    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const payload = {
        ...detailData,
        status: 'submitted',
        products,
      };

      // Check products stock
      const emptyStock = payload.products.find((p) => p.final_stock < 0);
      if (emptyStock && payload.status == 'submitted') {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({
          text1: `Stock in ${
            payload.inventory_type == 'add' ? 'warehouse' : 'inventory'
          } is not enough`,
          type: 'error',
        });
        return;
      }

      const requestConfirm = await MsOrder.updateInventoryStatus(
        detailData._id,
        'submitted',
        payload,
      );
      if (requestConfirm && requestConfirm.data && requestConfirm.data.data) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        dispatch(
          showAlert({
            show: true,
            title: 'New Inventory Submitted',
            description: 'New inventory successfully submitted.',
            isConfirm: false,
            onCallback: () => {
              getDetail(props.route.params.id);
            },
          }),
        );
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  const handleDelete = async () => {
    try {
      if (detailData && detailData._id) {
        dispatch(showPopup({ name: 'isLoading', value: true }));
        const removeInventory = await MsOrder.deleteInventory(detailData._id);
        if (
          removeInventory &&
          removeInventory.data &&
          removeInventory.data.data
        ) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Successfully deleted inventory',
            type: 'success',
          });
          props.navigation.navigate('InventoryScreen');
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Failed to delete inventory',
            type: 'error',
          });
        }
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  return (
    <Layout.Container>
      {getInventoryDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : detailData && Object.keys(detailData).length ? (
        <>
          {isWeb ? (
            <Layout.Wrapper white={false}>
              <Layout.Back title="Inventory" onCallback={() => goBack()} />
            </Layout.Wrapper>
          ) : (
            false
          )}
          <ScrollContainer
            style={{
              height: windowHeight * 0.93,
            }}>
            <Layout.Wrapper rounded>
              <View style={styles.sectionWrapper}>
                <View
                  style={[
                    styles.rowContainer,
                    {
                      position: 'relative',
                      zIndex: 1,
                      justifyContent: 'space-between',
                    },
                  ]}>
                  <View
                    style={[
                      styles.row,
                      {
                        marginBottom: isWeb ? 0 : 10,
                      },
                    ]}>
                    <Image
                      style={{ width: 36, height: 36, marginRight: 20 }}
                      width={36}
                      height={36}
                      isPhoto={true}
                      source={
                        detailData?.user?.image ? detailData?.user?.image : img
                      }
                    />
                    <View>
                      <SociollaText
                        type="medium"
                        style={{
                          fontSize: 24,
                          color: Colors.black3,
                        }}>
                        {detailData?.user?.name || '-'}
                      </SociollaText>
                      <SociollaText
                        type="medium"
                        style={{
                          fontSize: 12,
                          color: Colors.black3,
                        }}>
                        {detailData?.user?.sales_code || '-'}
                      </SociollaText>
                    </View>
                  </View>

                  {isWeb && detailData.status == 'draft' && showEditButton ? (
                    <View>
                      <View style={{ flexDirection: 'row' }}>
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{
                            width: 80,
                            marginRight: 10,
                          }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Edit
                            </SociollaText>
                          }
                          onPress={goToEdit}
                        />
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 80, marginRight: 10 }}
                          title={
                            <Image
                              style={{
                                width: trash.width,
                                height: trash.height,
                              }}
                              width={trash.width}
                              height={trash.height}
                              source={require('@assets/img/icons/trash-white.svg')}
                              svg={true}
                            />
                          }
                          onPress={handleDelete}
                        />
                      </View>
                      <View style={{ marginRight: 10, marginTop: 10 }}>
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{
                            width: '100%',
                            marginRight: 10,
                            backgroundColor: Colors.blue0,
                          }}
                          disabled={!isAvailableSubmit()}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Submit
                            </SociollaText>
                          }
                          onPress={handleSubmit}
                        />
                      </View>
                    </View>
                  ) : (
                    false
                  )}
                </View>
                <View
                  style={[
                    { maxWidth: isWeb ? 400 : '100%' },
                    isWeb ? { paddingVertical: 15 } : { paddingBottom: 20 },
                  ]}>
                  <ItemDetail
                    name="Status"
                    centered
                    value={<StatusBadge status={detailData.status} />}
                  />
                  <ItemDetail
                    name="Created Date"
                    value={
                      detailData.created_at
                        ? parseDate(
                            detailData.created_at,
                            'd MMMM yyyy HH:mm:ss',
                          )
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Inventory Type"
                    value={
                      detailData.inventory_type
                        ? parseInventoryType(detailData.inventory_type)
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Sales Team"
                    value={
                      detailData.sales_team.name
                        ? detailData.sales_team.name
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Warehouse"
                    value={
                      detailData.warehouse.name
                        ? detailData.warehouse.name
                        : '-'
                    }
                  />
                </View>
              </View>
              <View
                style={{
                  width: '100%',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: Colors.grey4,
                  paddingHorizontal: 20,
                  paddingVertical: 12,
                }}>
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: isWeb ? 16 : 13,
                    letterSpacing: 0.5,
                    color: Colors.grey1,
                  }}>
                  PRODUCT
                </SociollaText>
              </View>
              <View
                style={{
                  width: '100%',
                  paddingHorizontal: isWeb ? 30 : 0,
                  ...(isWeb ? { paddingVertical: 20 } : {}),
                }}>
                {products?.length ? (
                  (products || []).map((item, idx) => (
                    <ProductItem
                      data={item}
                      isShowStock={detailData?.status != 'submitted'}
                      key={idx}
                      withoutDiscount={true}
                      withoutCurrency={true}
                    />
                  ))
                ) : (
                  <View
                    style={{
                      paddingVertical: 20,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <Image
                      style={{ width: 30, height: 35 }}
                      width={30}
                      height={35}
                      source={require('@assets/img/icons/no-product.svg')}
                      svg={true}
                    />
                    <SociollaText style={{ marginVertical: 10 }}>
                      No product found
                    </SociollaText>
                  </View>
                )}
              </View>
              <View
                style={{
                  width: '100%',
                  backgroundColor: Colors.grey4,
                  paddingHorizontal: 20,
                  paddingVertical: 12,
                }}>
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: isWeb ? 16 : 13,
                    letterSpacing: 0.5,
                    color: Colors.grey1,
                  }}>
                  E-SIGNATURE
                </SociollaText>
              </View>
              <View
                style={[
                  styles.row,
                  { width: '100%', paddingHorizontal: 20, paddingVertical: 12 },
                ]}>
                <View style={{ width: '50%' }}>
                  <SociollaText>Requestor</SociollaText>
                  <Image
                    style={styles.esignImage}
                    width="50%"
                    height={100}
                    source={
                      detailData?.esign_requestor?.image
                        ? detailData?.esign_requestor?.image
                        : img
                    }
                  />
                  <SociollaText>
                    {detailData?.esign_requestor?.name ?? '-'}
                  </SociollaText>
                  <SociollaText
                    style={{
                      fontSize: 10,
                      color: '#999999',
                      textAlign: 'left',
                    }}>
                    {'Date:'}{' '}
                    {detailData?.esign_requestor?.created_at
                      ? moment(detailData?.esign_requestor?.created_at).format(
                          'DD MMM YYYY',
                        )
                      : '-'}
                  </SociollaText>
                </View>
                <View style={{ width: '50%' }}>
                  <SociollaText>Approver</SociollaText>
                  <Image
                    style={styles.esignImage}
                    width="50%"
                    height={100}
                    source={
                      detailData?.esign_approver?.image
                        ? detailData?.esign_approver?.image
                        : img
                    }
                  />
                  <SociollaText>
                    {detailData?.esign_approver?.name ?? '-'}
                  </SociollaText>
                  <SociollaText
                    style={{
                      fontSize: 10,
                      color: '#999999',
                      textAlign: 'left',
                    }}>
                    {'Date:'}{' '}
                    {detailData?.esign_approver?.created_at
                      ? moment(detailData?.esign_approver?.created_at).format(
                          'DD MMM YYYY',
                        )
                      : '-'}
                  </SociollaText>
                </View>
              </View>
            </Layout.Wrapper>
          </ScrollContainer>
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
  },
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
  esignImage: {
    width: '90%',
    height: 100,
    resizeMode: 'contain',
    marginVertical: isWeb ? 10 : 0,
  },
});

export default InventoryDetailScreen;
